export const REGEX_CONSTANT = {
  NON_DECIMAL_CHARS: /[^0-9.]/g,
  MULTIPLE_DOTS: /(\..*?)\..*/g,
  NON_UNICODE_TEXT_CHARS: /[^\p{L}\p{N}\p{P}\p{Z}\n]/gu,
};
